import {mobilemenu} from './mobilemenu';
import {slider} from './slider';
import {coverageMap} from './coverage-map';
import Stats from './stats';

(function($) {

    window.$ = jQuery;

    $(document).ready(function(){
		let stats = new Stats();

        slider();
        mobilemenu();
        initLightbox();
        initResonsiveEmbed();
        initResponsiveTables();
		coverageMap();
    });

})(jQuery);


/**
 * Init Lightcase (lightbox)
 * http://cornel.bopp-art.com/lightcase/documentation/
 */
function initLightbox() {
    $('a[data-rel^=lightcase]').lightcase({
        maxWidth: 1024,
        maxHeight: 768
    });
}
function initResonsiveEmbed() {
    $('iframe[src*="youtube"], iframe[src*="vimeo"]').each(function(){
        $(this).addClass('embed-responsive-item')
            .wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
    });
}

function initResponsiveTables() {
    $('table').each(function(){
        $(this).addClass('table')
            .wrap('<div class="table-responsive"></div>');
    });
}